import { useTranslation } from 'react-i18next';

/**
 * Home view component
 * @returns {JSX.Element} The Home component
 */
function Home() {
  // Hooks
  const { t } = useTranslation();

  return (
    <main>
      main
    </main>
  );
}

export default Home;
